import React, { FunctionComponent } from "react";
import {addParamToUrl} from "../../../utils/utils";

const Picture: FunctionComponent<any> = (props) => {
  const unavailableImage = "/content/dam/canon/default-img/image-unavailable.png";
  const unavailableImageProTab = "/content/dam/canon/default-img/image-unavailable-no-transparent.jpg";
  const headerMode = localStorage.getItem("header-mode");

  return (
    <picture className={props.pictureClass}>
      {props.thumbnailSrc?.includes('s7d1.scene7.com/') && (
        <source srcSet={addParamToUrl(props.thumbnailSrc, 'fmt', 'webp-alpha')} type="image/webp" />
      )}
      {props.thumbnailSrc?.includes('s7d1.scene7.com/') && (
        <source srcSet={addParamToUrl(props.thumbnailSrc, 'fmt', 'png-alpha')} type="image/png" />
      )}
      <img
        alt={props.altText}
        width="280"
        height="360"
        title={props.isSafari ? props.altTextTitle : ""}
        className={`${props.productClass} ${props.productClass == 'item-image' && headerMode == 'pro' ? 'proTab' : ''}`}
        src={props.thumbnailSrc || unavailableImage}
        onError={(e) => {
          const el = e.currentTarget as HTMLElement;
          const sourceTagUrl = el.parentNode?.children[0].getAttribute("srcset") || el.parentNode?.children[0].getAttribute("src");
          el.onerror = null;
          if (unavailableImage !== sourceTagUrl) {
            el.parentNode?.children[0]?.setAttribute("srcset", headerMode !== 'pro' ? unavailableImage : unavailableImageProTab);
            el.parentNode?.children[1]?.setAttribute("srcset", headerMode !== 'pro' ? unavailableImage : unavailableImageProTab);
            // el.classList.add('unavailable-image');
          }
        }}
      />
    </picture>
  );
};

export default Picture;
